module.exports = faker;